import { PlateCanvasLabels } from 'components/canvas/constants';
import { WellSelectionDetails } from 'redux/reducers/experimentDataReducer';

export async function fetchProfiles(expId, rockFetchGet) {
  const apiUrl = `api/CaptureProfile/CaptureProfileByExp/${expId}`;
  const result = await rockFetchGet(apiUrl);
  if (result === null) {
    return null;
  }
  return result;
}

export function createPlateLables(plateList, colCount) {
  if (plateList === undefined || plateList.length == 0) {
    return;
  }
  const newPlateLables = [...plateList]
    .sort((a, b) => a.plateNumber - b.plateNumber)
    .map((plate) => ({
      id: plate.plateId,
      name: 'Plate ' + ((plate.rowPos - 1) * colCount + plate.colPos),
    }));
  return newPlateLables;
}
export function getWellAndCanvasLabels(
  containerCols: number,
  containerRows: number,
): {
  wellLabels: WellLabelType[];
  canvasLabels: PlateCanvasLabels;
} {
  const wellLabels: WellLabelType[] = [];
  const columnLabels: string[] = [];
  const rowLabels: string[] = [];
  let id = 1;

  for (let row = 0; row < containerRows; row++) {
    let r = row;
    let rowLabel = '';
    while (r >= 0) {
      rowLabel = String.fromCharCode((r % 26) + 65) + rowLabel;
      r = Math.floor(r / 26) - 1;
    }

    rowLabels.push(rowLabel);

    for (let col = 1; col <= containerCols; col++) {
      if (row === 0) {
        columnLabels.push(col.toString());
      }

      wellLabels.push({
        id,
        wellNumber: id,
        name: rowLabel + col,
      });
      id++;
    }
  }

  return {
    wellLabels,
    canvasLabels: {
      columnLabels,
      rowLabels,
    },
  };
}

export function getLatestInspection(docData) {
  let inspectionSet = undefined;
  if (docData.inspections) {
    if (docData.inspections.length) {
      inspectionSet = docData.inspections[docData.inspections.length - 1];
    }
  }
  return inspectionSet;
}
export function getInspectionSetBatchId(docData, imgBatchId) {
  let inspectionSet = undefined;
  if (docData.inspections) {
    if (docData.inspections.length) {
      inspectionSet = docData.inspections.find((insp) =>
        insp.groupedInspections.some((ginsp) => ginsp.id == imgBatchId),
      );
    }
  }
  return inspectionSet;
}

export function getDefaultInspection(docData) {
  let inspectionSet = undefined;
  if (docData?.inspections) {
    if (docData.inspections?.length) {
      if (docData.expSelectedStates) {
        inspectionSet = docData.inspections.find(
          (insp) => insp.id == docData.expSelectedStates.inspectionSetId,
        );
      }
    }
  }
  return inspectionSet;
}

export function getDefaultPlate(docData) {
  return getPlateByNumber(docData, getDefaultPlateNumber(docData));
}

export function getDefaultPlateNumber(docData) {
  if (docData.expSelectedStates) {
    return docData.expSelectedStates.plateNumber;
  }
  return 1;
}

export function getDefaultWellNumber() {
  return 1;
}

export function getDefaultDropNumber(docData) {
  if (docData.expSelectedStates) {
    return docData.expSelectedStates.dropNumber;
  }
  return 1;
}

export function getPlateByNumber(docData, plateNumber) {
  if (docData.plateDto === undefined || docData.plateDto.length == 0) {
    return;
  }
  for (const plate of docData.plateDto) {
    if ((plate.rowPos - 1) * docData.colCount + plate.colPos == plateNumber) {
      return plate;
    }
  }
  return null;
}

export function getDefaultCaptureProfileId(docData) {
  if (docData.expSelectedStates) {
    return docData.expSelectedStates.captureProfileId;
  } else if (docData.profiles && docData.profiles.length > 0) {
    return docData.profiles[0].id;
  }
}

export function getDefaultRegion(docData) {
  if (docData.expSelectedStates) {
    return docData.expSelectedStates.regionName;
  }

  return 'Drop';
}

export const getDefaultWellSelection = (exp) => {
  const defaultPlate = getDefaultPlate(exp);
  const defaultDropImageParameters = {
    cpId: getDefaultCaptureProfileId(exp),
    dropNumber: getDefaultDropNumber(exp),
    regionName: getDefaultRegion(exp),
    inspection: getLatestInspection(exp),
  };
  return {
    wellNavigationDetails: [
      {
        plateNum: defaultPlate?.plateNumber,
        plateID: defaultPlate?.plateId,
        wellNum: getDefaultWellNumber(),
      },
    ],
    dropImageParameters: [defaultDropImageParameters],
    selectedDropImageParameters: defaultDropImageParameters,
  } as WellSelectionDetails;
};

export function getRegionId(regions, wellNum, dropNumber, regionName, plateID) {
  const selectedRegion = regions?.find((r) => r.name == regionName);
  let regionDetail;
  if (selectedRegion) {
    if (selectedRegion.drops) {
      regionDetail = selectedRegion.drops.find(
        (d) =>
          d.plateId == plateID && d.wellNumber == wellNum && d.dropNumber == dropNumber,
      );
    }
  }
  if (regionDetail) {
    return regionDetail.regionId;
  }

  return undefined;
}

export interface WellLabelType {
  id: number;
  wellNumber: number;
  name: string;
}
